import { OrganizationTheme, ThemeColor } from 'types'

export const themeColors: Record<OrganizationTheme, ThemeColor> = {
  primary: {
    50: '#faf4f0',
    100: '#f6e9e0',
    200: '#ecd3c0',
    300: '#e3bba2',
    400: '#e5a97e',
    500: '#d9884e',
    600: '#c97e48',
    700: '#a6683b',
    800: '#663714',
    900: '#401f06',
    main: '#c97e48',
    contrastText: '#ffffff',
  },
  red: {
    50: '#fcefee',
    100: '#f8dfdd',
    200: '#ffccca',
    300: '#f9b0aa',
    400: '#e88e87',
    500: '#cf5951',
    600: '#d83c30',
    700: '#ab2a21',
    800: '#89231b',
    900: '#561510',
    main: '#d83c30',
    contrastText: '#ffffff',
  },
  blue: {
    50: '#eaf8ff',
    100: '#d6f1ff',
    200: '#c2eaff',
    300: '#ade1ff',
    400: '#85c4e5',
    500: '#5cb6e5',
    600: '#309dd9',
    700: '#2177a6',
    800: '#1c658c',
    900: '#003049',
    main: '#309dd9',
    contrastText: '#ffffff',
  },
  green: {
    50: '#f3f7f3',
    100: '#e6efe7',
    200: '#d2f1d9',
    300: '#bfe1c7',
    400: '#9bbfa2',
    500: '#75a77f',
    600: '#588960',
    700: '#48704f',
    800: '#38573d',
    900: '#203223',
    main: '#588960',
    contrastText: '#ffffff',
  },
  purple: {
    50: '#f3ecfd',
    100: '#f1e5ff',
    200: '#ddc7ff',
    300: '#d3b3ff',
    400: '#b18ae5',
    500: '#955ce5',
    600: '#7630d9',
    700: '#5821a6',
    800: '#4c1c8c',
    900: '#2c095d',
    main: '#7630d9',
    contrastText: '#ffffff',
  },
}
